
import { Button } from "@/components/ui/button";

interface BroCodeActionsProps {
  openRerollDialog: () => void;
  openBrometheusDialog: () => void;
  twitterShareUrl: string;
  walletAddress: string;
  isShadowBro: boolean;
  onClickTelegram: () => void;
  onClickTwitter?: () => void;
}

const BroCodeActions = ({ 
  openRerollDialog, 
  openBrometheusDialog, 
  twitterShareUrl, 
  walletAddress: _walletAddress,
  isShadowBro,
  onClickTelegram,
  onClickTwitter
}: BroCodeActionsProps) => {
  if (isShadowBro) return null;

  const handleTwitterClick = onClickTwitter || (() => {
    window.open(twitterShareUrl, '_blank');
  });

  return (
    <div className="mt-8 space-y-6">
      {/* Main Action Buttons */}
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <Button
          onClick={openRerollDialog}
          className="bg-navy-dark text-tan border border-tan-dark hover:bg-navy transition-colors"
        >
          🌀 Reroll BroCode
        </Button>
        
        <Button
          onClick={openBrometheusDialog}
          className="bg-navy-dark text-tan border border-tan-dark hover:bg-navy transition-colors"
        >
          ⚡ Claim BROMETHEUS
        </Button>
      </div>
      
      {/* BroScore Boost Section */}
      <div className="bg-gradient-to-r from-amber-50 to-yellow-50 border border-amber-300 p-4 rounded-lg">
        <div className="flex items-center justify-center space-x-2 mb-2">
          <span className="text-2xl">🚀</span>
          <h3 className="font-bold text-amber-800">Boost Your Airdrop Allocation</h3>
        </div>
        <p className="text-amber-700 text-sm mb-4">
          Each social action earns +15 BroScore, improving your future airdrop allocation!
        </p>
        
        <div className="space-y-2">
          <Button
            onClick={handleTwitterClick}
            className="w-full bg-blue-500 text-white hover:bg-blue-600 transition-colors font-bold py-3"
          >
            🐦 Share on Twitter (+15 BroScore)
          </Button>
          
          <Button
            onClick={onClickTelegram}
            className="w-full bg-blue-600 text-white hover:bg-blue-700 transition-colors font-bold py-3"
          >
            📱 Verify on Telegram (+15 BroScore)
          </Button>
        </div>
      </div>
    </div>
  );
};

export default BroCodeActions;
